// extracted by mini-css-extract-plugin
export default {"list":"FragmentsDescriptionNotify_list__0D32f"};